import React from 'react'
import { MInputTextField, MButton, BufferService, LoadingContext } from 'src/M_Components'
import EmailIcon from '@mui/icons-material/Email'
import KeyIcon from '@mui/icons-material/Key'


import './LoginForm.css'

export default function LoginForm({ onForgotPassword, handleLoginSubmit, handleEnter, setEmail, setPassword, t, ctx}) {
    
    //============================================================================================================
    // Renders the login form
    //============================================================================================================
    return (
        <div className="login-form-container">
            <MInputTextField // Email input field
                cy='email'
                iconStart={<EmailIcon className='login-icon' />}
                label={t("textFieldEmailLabel")}
                type={"text"}
                onChange={e => setEmail(e.target.value)}
                onKeyDown={handleEnter}
            />
            <MInputTextField
                cy='password' // Password input field
                iconStart={<KeyIcon className='login-icon' />}
                label={t("textFieldPasswordLabel")}
                type={"password"}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={handleEnter}
            />
            <div className="login-button-group">
                <MButton // Submit button for the login form
                    bold
                    label={t("LoginButton")}
                    labelColor={'var(--color-white)'}
                    onClick={() => handleLoginSubmit()}
                    backgroundColor={ctx.secondaryColor}
                    borderColor={ctx.secondaryColor}
                />
            </div>
            <div className="forgot-password" onClick={() => onForgotPassword(true)}>
                {t("ForgotPassword")}
            </div>
        </div>
    )
}
